import { Box, FormControlLabel, FormHelperText, Switch } from '@mui/material';

import { type UseToggleFieldProps, useToggleField } from './useToggleField';

export function BlockSwitchField<TActiveState = boolean, TInactiveState = boolean>(
  props: UseToggleFieldProps<TActiveState, TInactiveState>
) {
  const { controlProps, label, displayedHelperText, isFieldErrorVisible } = useToggleField(props);
  return (
    <Box>
      <FormControlLabel control={<Switch {...controlProps} />} label={label} />
      {displayedHelperText && (
        <FormHelperText error={isFieldErrorVisible}>{displayedHelperText}</FormHelperText>
      )}
    </Box>
  );
}
